import * as constants from './constants';
import * as g_constants from '../global/constants';

const initialState = {
  user: null,
  active: 'dashboard',
  messagingClient: null,
  messagingToken: null,
  notificationCount: 0
};

export default function Dashboard(state = initialState, action) {
  let user = null;
  switch (action.type) {
    case constants.SET_USER_DATA:
      return Object.assign({}, state, {
        user: action.data
      });
    case constants.SET_ACTIVE_TAB:
      return Object.assign({}, state, {
        active: action.data
      });
    case constants.SET_PAYMENT_METHODS:
      user = {
        ...state.user,
        bankAccounts: action.data.bankAccounts,
        creditCards: action.data.creditCards
      };
      return Object.assign({}, state, {
        user: user
      });
    case constants.SET_STRIPE_URI:
      user = {
        ...state.user,
        stripeAccountUri: action.data.url
      };
      return Object.assign({}, state, { user: user });
    case constants.SET_MESSAGING_TOKEN:
      return Object.assign({}, state, {
        messagingToken: action.data
      });
    case constants.SET_MESSAGING_CLIENT:
      return Object.assign({}, state, {
        messagingClient: action.data
      })
    case constants.SET_NOTIFICATION_COUNT:
      return Object.assign({}, state, {
        notificationCount: action.data
      })
    case g_constants.IMPERSONATE:
    case g_constants.LOGOUT:
      if (state.messagingClient) {
        state.messagingClient.shutdown();
      }
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
